import classNames from "classnames/bind";
import style from './TabBar.module.css';
import { useEffect, useState } from "react";
import { TabBarConfigObject, TabBarDefault } from "./config";

const cx = classNames.bind(style);

function TabBar({ serviceCode, active, handleChose }) {
    const [tabBarDefault, setTabBarDefault] = useState(TabBarDefault)
    useEffect(() => {
        if (serviceCode === '20230222000000000004' || serviceCode === '20230222000000000006') {
            setTabBarDefault(TabBarConfigObject)
        } else {
            setTabBarDefault(TabBarDefault)
        }
    }, [serviceCode])
    return (
        <div className={cx("content-config")}>
            <div className={cx("controller")}>
                {tabBarDefault &&
                    tabBarDefault?.map((item) => {
                        return (
                            <div
                                className={cx(
                                    "button-control",
                                    active === item.id && "button-active"
                                )}
                                onClick={() => handleChose(item.id)}
                                key={item.id}
                            >
                                {item.label}
                            </div>
                        );
                    })}
            </div>
        </div>
    )
}

export default TabBar;